module.exports = __webpack_public_path__ + "img/1649252329895strublogo.cd749f12.jpg";